import {Directive, HostListener} from '@angular/core';

@Directive({
	selector: '[appNoClick]'
})
export class NoClickDirective {
	@HostListener('click', ['$event']) onClick($event: Event): void {
		$event.preventDefault();
		$event.stopPropagation();
	}
}
